export const STATIC_TOOLBAR_DATA_HOOK = 'static-toolbar';
